var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollableContentWidth",staticClass:"lv-scrollable-block-content",class:{
    small: _vm.small,
    bottom: _vm.bottom,
    noPadding: _vm.noPadding,
    alignCenter: _vm.alignCenter,
    transparent: _vm.transparent,
    paddingDefault: _vm.paddingDefault,
    'auto-height': _vm.isAutoHeight,
    'justify-content-center': _vm.justifyCenter,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }